import { useTranslation } from 'react-i18next'

import { returnMethods, returnMethodsWithCarrierSetup } from '../constants'
import SectionHeader from '../SectionHeader/SectionHeader'
import CustomerDeliversMethod from './CustomerDeliversMethod/CustomerDeliversMethod'
import CustomerPickUpMethod from './CustomerPickUpMethod/CustomerPickUpMethod'
import PickUpPointMethod from './PickUpPointMethod/PickUpPointMethod'
import ReturnToStoreMethod from './ReturnToStoreMethod/ReturnToStoreMethod'
import * as Styles from './styles'

const LogisticsSection = ({
  deliveryMethodType,
  config,
  onChange,
  errors,
  subscriptionPlan,
  carriers,
  carrierServices,
  onCarrierChange,
  manageCarrierService,
  onManageCarrierServiceChange,
  isLoadingCarrierServices,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {returnMethodsWithCarrierSetup.includes(deliveryMethodType) && (
        <SectionHeader
          title={t('Logística')}
          description={t('Configura el transportista y los ajustes de este tipo de método')}
        />
      )}
      {deliveryMethodType === returnMethods.customerpickup && (
        <CustomerPickUpMethod
          config={config}
          onChange={onChange}
          errors={errors}
          subscriptionPlan={subscriptionPlan}
          carriers={carrierServices}
          onCarrierChange={onCarrierChange}
          disabled={disabled}
        />
      )}
      {deliveryMethodType === returnMethods.customerdelivers && (
        <CustomerDeliversMethod config={config} onChange={onChange} errors={errors} />
      )}
      {deliveryMethodType === returnMethods.pickuppoint && (
        <PickUpPointMethod
          config={config}
          onChange={onChange}
          errors={errors}
          subscriptionPlan={subscriptionPlan}
          carriers={carriers}
          onCarrierChange={onCarrierChange}
          carrierServices={carrierServices}
          manageCarrierService={manageCarrierService}
          onManageCarrierServiceChange={onManageCarrierServiceChange}
          isLoadingCarrierServices={isLoadingCarrierServices}
          disabled={disabled}
        />
      )}
      {deliveryMethodType === returnMethods.returntostore && (
        <ReturnToStoreMethod config={config} onChange={onChange} />
      )}
    </Styles.Container>
  )
}

export default LogisticsSection
